"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: property/display.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.Display = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
exports.protobufPackage = "property";
function createBaseDisplay() {
    return {
        internetAddressDisplay: false,
        internetEntireListingDisplay: false,
        internetAutomatedValuationDisplay: false,
        termsOfUseRequired: false,
    };
}
exports.Display = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.internetAddressDisplay !== false) {
            writer.uint32(8).bool(message.internetAddressDisplay);
        }
        if (message.internetEntireListingDisplay !== false) {
            writer.uint32(16).bool(message.internetEntireListingDisplay);
        }
        if (message.internetAutomatedValuationDisplay !== false) {
            writer.uint32(24).bool(message.internetAutomatedValuationDisplay);
        }
        if (message.termsOfUseRequired !== false) {
            writer.uint32(32).bool(message.termsOfUseRequired);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDisplay();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.internetAddressDisplay = reader.bool();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.internetEntireListingDisplay = reader.bool();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.internetAutomatedValuationDisplay = reader.bool();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.termsOfUseRequired = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            internetAddressDisplay: isSet(object.internetAddressDisplay)
                ? globalThis.Boolean(object.internetAddressDisplay)
                : false,
            internetEntireListingDisplay: isSet(object.internetEntireListingDisplay)
                ? globalThis.Boolean(object.internetEntireListingDisplay)
                : false,
            internetAutomatedValuationDisplay: isSet(object.internetAutomatedValuationDisplay)
                ? globalThis.Boolean(object.internetAutomatedValuationDisplay)
                : false,
            termsOfUseRequired: isSet(object.termsOfUseRequired) ? globalThis.Boolean(object.termsOfUseRequired) : false,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.internetAddressDisplay !== false) {
            obj.internetAddressDisplay = message.internetAddressDisplay;
        }
        if (message.internetEntireListingDisplay !== false) {
            obj.internetEntireListingDisplay = message.internetEntireListingDisplay;
        }
        if (message.internetAutomatedValuationDisplay !== false) {
            obj.internetAutomatedValuationDisplay = message.internetAutomatedValuationDisplay;
        }
        if (message.termsOfUseRequired !== false) {
            obj.termsOfUseRequired = message.termsOfUseRequired;
        }
        return obj;
    },
    create(base) {
        return exports.Display.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseDisplay();
        message.internetAddressDisplay = (_a = object.internetAddressDisplay) !== null && _a !== void 0 ? _a : false;
        message.internetEntireListingDisplay = (_b = object.internetEntireListingDisplay) !== null && _b !== void 0 ? _b : false;
        message.internetAutomatedValuationDisplay = (_c = object.internetAutomatedValuationDisplay) !== null && _c !== void 0 ? _c : false;
        message.termsOfUseRequired = (_d = object.termsOfUseRequired) !== null && _d !== void 0 ? _d : false;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=display.js.map